<template lang="pug">
#canvas-wrapper(ref="canvasWrapper")
  .rent-object-cover(:style="{width: xStepSizeWidthCount * xStepSize + 'px', height: 2 * yStepSize + 'px'}")
    .top
      b-button(type="is-text" icon-left="refresh" @click="reloadPage()") Reset
      ProgressBar
    .bottom
      .left {{searchResults.length}}x Mietobjekte
      .right
        //- b-button(type="is-text" icon-left="sort-alphabetical-descending-variant")
        //- b-button(type="is-text" icon-left="sort-alphabetical-ascending-variant")
        b-button(type="is-text" icon-left="")


  OfferSidebar(v-if="showOfferSidebar" :offers="selectedOffers" @close="showOfferSidebar = false" @refresh="drawOffers()")

  BookingMenu(v-if="menuMode !== 'new' || (bookingAllowed && menuMode === 'new')"
              :showMenu="showMenu"
              @close="showMenu=false",
              @addOffer="(d) => addOffer(d)"
              @sendOffer="(b) => {selectedBooking = b; showSendOfferModal = true}",
              @resendOffer="(b) => {selectedBooking = b; showResendOfferModal = true}",
              @sendContract="(b) => {selectedBooking = b; showSendContractModal = true}",
              @resendContract="(b) => {selectedBooking = b; showResendContractModal = true}",
              @resendCancelInvoice="(b) => {selectedBooking = b; showResendCancelInvoiceModal = true}",
              @contractBack="(b) => {selectedBooking = b; showReceiveContractModal = true}",
              @savePayment="(b) => {selectedBooking = b; showPaymentModal = true}",
              @sendCancel="(b) => {selectedBooking = b; showSendCancelModal = true}",
              @sendCancelInvoice="(b) => {selectedBooking = b; showSendCancelInvoiceModal = true}",
              @refreshInbox="refreshInbox()",
              :mode="menuMode",
              :bookings="hitBookings",
              :newBooking="newBooking",
              :settings="settings",
              :pos="mouseClickPos")
  
  BookingHoverInfos(v-if="xStepSize * xStepSizeWidthCount < mousePos.x" :mousePos="mousePos" :bookings="hitBookings" :bookingStatus="bookingStatus" :showMenu="showMenu")
  HolidayHoverInfos(:mousePos="mousePos" :matchedHolidays="matchedHolidays")

  b-modal(v-model='showSendOfferModal' has-modal-card full-screen trap-focus aria-role='dialog' aria-modal)
    template(#default='props')
      SendOfferModal(:booking="selectedBooking"
                    @close='props.close(); jumpToBooking()'
                    @refreshInbox="refreshInbox()")

  b-modal(v-model='showSendContractModal' has-modal-card full-screen trap-focus aria-role='dialog' aria-modal)
    template(#default='props')
      SendContractModal(:booking="selectedBooking"
                    @close='props.close(); jumpToBooking()'
                    @updateBookingData="(data) => updateBookingData(data)")

  b-modal(v-model='showResendOfferModal' has-modal-card full-screen trap-focus aria-role='dialog' aria-modal)
    template(#default='props')
      ResendOfferModal(:booking="selectedBooking"
                    @close='props.close(); jumpToBooking()'
                    @refreshInbox="refreshInbox()")

  b-modal(v-model='showResendContractModal' has-modal-card full-screen trap-focus aria-role='dialog' aria-modal)
    template(#default='props')
      ResendContractModal(:booking="selectedBooking"
                    @close='props.close(); jumpToBooking()'
                    @refreshInbox="refreshInbox()")

  b-modal(v-model='showResendCancelInvoiceModal' has-modal-card full-screen trap-focus aria-role='dialog' aria-modal)
    template(#default='props')
      ResendCancelInvoiceModal(:booking="selectedBooking"
                    @close='props.close(); jumpToBooking()'
                    @refreshInbox="refreshInbox()")

  b-modal(v-model='showReceiveContractModal' has-modal-card full-screen trap-focus aria-role='dialog' aria-modal)
      template(#default='props')
        ReceiveContractModal(:booking="selectedBooking"
                      @close='props.close(); jumpToBooking()'
                      @updateBookingData="(data) => updateBookingData(data)")

  b-modal(v-model='showPaymentModal' has-modal-card full-screen trap-focus aria-role='dialog' aria-modal)
    template(#default='props')
      PaymentModal(:booking="selectedBooking"
                    @close='props.close(); jumpToBooking()'
                    @refreshInbox="refreshInbox()")

  b-modal(v-model='showSendCancelModal' has-modal-card full-screen trap-focus aria-role='dialog' aria-modal)
    template(#default='props')
      SendCancelModal(:booking="selectedBooking"
                    @close='props.close(); jumpToBooking()'
                    @refreshInbox="refreshInbox()")

  b-modal(v-model='showSendCancelInvoiceModal' has-modal-card full-screen trap-focus aria-role='dialog' aria-modal)
    template(#default='props')
      SendCancelInvoiceModal(:booking="selectedBooking"
                    @close='props.close(); jumpToBooking()'
                    @refreshInbox="refreshInbox()")
</template>

<script>
import { DateTime } from "luxon"
import BookingMenu from "@/components/molecules/BookingMenu.vue";
import { Application, Container, TextStyle, Graphics, Sprite, BitmapFont, BitmapText, utils } from 'pixi.js';

import ProgressBar from "@/components/atoms/ProgressBar.vue";
import BookingHoverInfos from "@/components/atoms/BookingHoverInfos.vue";
import HolidayHoverInfos from "@/components/atoms/HolidayHoverInfos.vue";
import OfferSidebar from "@/components/molecules/OfferSidebar.vue";

//Modals
import SendOfferModal from "@/components/molecules/SendOfferModal.vue";
import SendContractModal from "@/components/molecules/SendContractModal.vue";
import ResendOfferModal from "@/components/molecules/ResendOfferModal.vue";
import ResendContractModal from "@/components/molecules/ResendContractModal.vue";
import ResendCancelInvoiceModal from "@/components/molecules/ResendCancelInvoiceModal.vue";
import ReceiveContractModal from "@/components/molecules/ReceiveContractModal.vue";
import PaymentModal from "@/components/molecules/PaymentModal.vue";
import SendCancelModal from "@/components/molecules/SendCancelModal.vue";
import SendCancelInvoiceModal from "@/components/molecules/SendCancelInvoiceModal.vue";

Date.prototype.getWeek = function() {
  var date = new Date(this.getTime());
  date.setHours(0, 0, 0, 0);
  // Thursday in current week decides the year.
  date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
  // January 4 is always in week 1.
  var week1 = new Date(date.getFullYear(), 0, 4);
  // Adjust to Thursday in week 1 and count number of weeks from date to week1.
  return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000
                        - 3 + (week1.getDay() + 6) % 7) / 7);
}

Date.prototype.addDays = function(days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
}

const xStepSizeWidthCount = 14;

export default {
  components: {
    ProgressBar,
    BookingHoverInfos,
    BookingMenu,
    SendOfferModal,
    SendContractModal,
    ResendOfferModal,
    ResendContractModal,
    ResendCancelInvoiceModal,
    ReceiveContractModal,
    SendCancelModal,
    SendCancelInvoiceModal,
    PaymentModal,
    OfferSidebar,
    HolidayHoverInfos
  },
  props: {
    searchResults: {
      type: Array
    },
    newDate: {
      type: Date
    },
    newDateRange: {
      type: Object
    }
  },
  data() {
    return {
      // Filters
      objectNameSearchString: "",

      // Modals
      showPaymentModal: false,
      showSendOfferModal: false,
      showSendContractModal: false,
      showReceiveContractModal: false,
      showSendCancelInvoiceModal: false,
      showSendCancelModal: false,
      showResendOfferModal: false,
      showResendContractModal: false,
      showResendCancelInvoiceModal: false,

      // For touch events on mobile
      previousTouchX: null,
      previousTouchY: null,
      
      // Config
      bookingAllowed: false,
      app: null,
      xStepSize: 25,
      yStepSize: 40,
      topLabelHeight: 0,
      xStepSizeWidthCount: xStepSizeWidthCount,
      height: window.innerHeight - 180 - 80,
      width: window.innerWidth,
      hoverCell: null,
      xScrollVelocity: 0,
      yScrollVelocity: 0,
      yOffsetScroll: 0,
      dayContainer: null,
      weekdayContainer: null,
      weekContainer: null,
      monthContainer: null,
      showMenu: false,
      mouseClickPos: {x:0, y:0},
      mouseMode: null,
      mouseMoved: false,
      hitBookings: [],
      selectedBooking: null,
      showOfferSidebar: false,
      clickOnNewBooking: false,
      clickOnExistingBooking: false,
      mousePos: {x: 0, y:0},
      highlightRange: {
        startDate: null,
        endDate: null
      },
      newBooking: {
        rentObjectId: null,
        startDate: null,
        endDate: null,
      },
      newBookingObj: {
        rectangle: null,
        text: null
      },
      menuMode: "new",

      // Calendar relevant
      highlightDay: {
        date: DateTime.local().set({hours: 20}).toJSDate(), // needs to be later than currentdate so that DIFF is working properly UPDATE: April 25th, 2022 - weired beahvior needed to increase by one hour
        rectangle: null,
        text: null
      },
      dayLabels: [],
      weekdayLabels: [],
      weekLabels: [],
      monthLabels: [],
      xGrid: [],
      yGrid: [],
      rentObjects: [],
      bookings: [],
      offers: [],
      MAX_DISPLAY_BOOKINGS: 1500,
      NEW_TIMEFRAME_THRESHOLD: 55,
      TIMEFRAME_BUFFER: 60,
      bookingTexturePool: [],
      bookingSpriteAndTextPool: [],
      currentDate: this.$route.query.jumpDate ? DateTime.fromHTTP(this.$route.query.jumpDate).minus({days: xStepSizeWidthCount}).set({hours: 18}).toJSDate() : DateTime.local().minus({days: xStepSizeWidthCount}).set({hours: 18}).toJSDate(),
      timeframe: {
        startDate: null,
        endDate: null,
      },
      weekdays: [
        "So",
        "Mo",
        "Di",
        "Mi",
        "Do",
        "Fr",
        "Sa"
      ],
      monthName: [
        "Januar",
        "Februar",
        "März",
        "April",
        "Mai",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Dezember",
      ],
      textStyle: null,
      holidays: [],
      matchedHolidays: []
    };
  },
  created() {
    window.addEventListener("resize", this.resizeEvent);
  },
  beforeDestroy() {
    const canvasWrapper = this.$refs.canvasWrapper;
    canvasWrapper.removeEventListener('touchmove', this.scrollEvent);
    this.$store.commit("rentObjectBookings/setSearchAndFilterMode", 'search');
    this.app.destroy(true, {"children": true});
    window.removeEventListener("resize", this.resizeEvent);
  },
  async mounted() {
    // Here we set the timeframe
    const dayWidth = Math.floor(this.width / this.xStepSize);
    const startDate = DateTime.fromJSDate(this.currentDate).minus({days: this.NEW_TIMEFRAME_THRESHOLD}).toJSDate();
    const endDate = DateTime.fromJSDate(this.currentDate).plus({days: dayWidth + this.NEW_TIMEFRAME_THRESHOLD}).toJSDate();
    const startDateBuffer = DateTime.fromJSDate(this.currentDate).minus({days: this.TIMEFRAME_BUFFER}).toJSDate();
    const endDateBuffer = DateTime.fromJSDate(this.currentDate).plus({days: dayWidth + this.TIMEFRAME_BUFFER}).toJSDate();

    this.$nextTick(async () => {
      this.$root.$emit('setNewTimeframe', {
        startDate: startDateBuffer,
        endDate: endDateBuffer,
      });
      this.timeframe = {
        startDate,
        endDate,
      }
      this.holidays = await this.$store.dispatch('holidays/findBetweenRange', {startDate: startDateBuffer, endDate: endDateBuffer})
    });

    // Some data we need
    this.$store.dispatch("commissions/findAll");
    
    // Filter
    this.$root.$on('jumpToBooking', (r) => {
      this.jumpToBooking(r);
    });

    // Here is the relevant stuff
    this.topLabelHeight = this.yStepSize / 2 * 4;
    this.app = new Application({
      transparent: true,
      antialias: false
    });
    // Here we load the settings
    await this.$store.dispatch("settings/find");
    this.initBookingCalendar();
  },
  watch: {
    searchResults(newVal, oldVal) {
      if (newVal.length !== oldVal.length) {
        this.yOffsetScroll = 0;
      }
      this.drawBookings();
      this.initRentObjects();
      this.detectQueryParameters();
    },
    newDate() {
      // this.currentDate = this.newDate.addDays(parseInt(this.width/2/this.xStepSize*-1));
      // TODO -18 ???
      // just to be sure that the data is correct
      if (this.newDate.getFullYear() < 1000) return;

      this.currentDate = DateTime.fromJSDate(this.newDate).set({hours: 19}).plus({days: (this.xStepSizeWidthCount+5)*-1}).toJSDate();
      this.highlightDay.date = DateTime.fromJSDate(this.newDate).set({hours: 19}).plus({days: 1}).toJSDate();
      this.resizeEvent();
    },
    newDateRange: {
      deep: true,
      handler() {
        if (this.newDateRange && this.newDateRange.startDate && this.newDateRange.endDate) {
          const range = {...this.newDateRange};
          // this.currentDate = this.newDateRange.startDate.addDays(parseInt((this.width/2/this.xStepSize+this.newDateRange.days)*-1));
          this.currentDate = DateTime.fromJSDate(range.startDate).set({hour: 18}).plus({days: (this.xStepSizeWidthCount+5)*-1}).toJSDate();
          this.highlightRange = {
            startDate: this.newDateRange.startDate,
            endDate: this.newDateRange.endDate,
          }
        }
        this.resizeEvent();
      }
    }
  },
  computed: {
    settings() {
      return this.$store.state.settings.single;
    },
    selectedOffers() {
      return this.$store.state.offers.selectedOffers
    },
    selectedOffersSortedByRentObjects() {
      const o = this.$store.state.offers.selectedOffers;
      const sortedOffers = [];
      for (let i = 0; i < this.searchResults.length; i += 1) {
        sortedOffers.push({...this.searchResults[i], rentObjectBookings: []});
        for (let x = 0; x < o.length; x += 1) {
          if (o[x].rentObjectId === this.searchResults[i].id) {
            sortedOffers[i].rentObjectBookings.push(o[x]);
          }
        }
      }
      return sortedOffers;
    },
    bookingStatus() {
      return this.$store.state.bookingStatus.all
    },
    commissions() {
      return this.$store.state.commissions.all
    },
    rentObject() {
      return this.$store.state.rentObjects.single;
    },
    rentObjectTypes() {
      return this.$store.state.rentObjectTypes.all
    },
  },
  methods: {
    async initBookingCalendar() {
      const canvasWrapper = this.$refs.canvasWrapper;
      this.app.renderer.view.style.position = "absolute";
      this.app.renderer.view.style.display = "block";
      this.app.renderer.autoResize = true;
      this.app.stage.sortableChildren = true;
      this.app.renderer.resize(this.width, this.height);

      canvasWrapper.appendChild(this.app.view);
      canvasWrapper.onwheel = this.scrollEvent;
      canvasWrapper.addEventListener('touchmove', this.scrollEvent);
      canvasWrapper.onmousemove = this.mouseMove;
      canvasWrapper.onmousedown = this.mouseDown;
      canvasWrapper.onmouseup = this.mouseUp;
      
      this.rentObjectContainer = new Container();
      this.rentObjectContainer.zIndex = 99;
      this.app.stage.addChild(this.rentObjectContainer);
      
      this.bookingContainer = new Container();
      this.bookingContainer.zIndex = 97;
      this.app.stage.addChild(this.bookingContainer);
      
      this.newBookingContainer = new Container();
      this.newBookingContainer.zIndex = 98;
      this.app.stage.addChild(this.newBookingContainer);

      // Offer Selection
      if (this.selectedOffers.length > 0) {
        this.showOfferSidebar = true;
      }

      // Init all Elements
      this.textStyle = new TextStyle({
        fontFamily: "Arial",
        align: "center",
        fill: "black",
        fontSize: 12
      });
      this.textStyleBold = new TextStyle({
        fontFamily: "Arial",
        align: "center",
        fill: "black",
        fontWeight: "bold",
        fontSize: 12
      });
      this.textStyleBoldWhite = new TextStyle({
        fontFamily: "Arial",
        align: "center",
        fill: "white",
        dropShadow: true,
        // dropShadowAngle: Math.PI,
        dropShadowBlur: 8,
        dropShadowColor: 0xe91e63,
        fontWeight: "bold",
        fontSize: 12
      });
      this.textStyle16 = new TextStyle({
        fontFamily: "Arial",
        align: "center",
        fill: "black",
        fontSize: 16
      });
      this.whiteTextStyle = new TextStyle({
        fontFamily: "Arial",
        align: "center",
        fill: "white",
        fontSize: 16
      });
      const charOptions = {
        chars: [['a', 'z'], ['A', 'Z'], ['0', '9'], ".,ßÄÜÖäüö-?!@#$%^&*()~{}[]/ "]
      };
      BitmapFont.from("fontArial16", this.textStyle16, charOptions);
      BitmapFont.from("fontArial", this.textStyle, charOptions);
      BitmapFont.from("fontArialBold", this.textStyleBold, charOptions);
      BitmapFont.from("fontArialBoldWhite", this.textStyleBoldWhite, charOptions);
      BitmapFont.from("whiteFontArial16", this.whiteTextStyle, charOptions);

      // Here we create the textures
      this.createTexturesForMaxWidthDays(100); // // This means max = 100 days a booking
      // TODO: Wenn eine Buchung größer als 100 Tage ausgewählt wurde, dann zeigen wir einen Error an
      this.pregenerateSpriteAndText(this.MAX_DISPLAY_BOOKINGS); // This means max = 500 bookings
      await this.$store.dispatch("rentObjectTypes/findAll");
      this.drawUI();
    },
    createTexturesForMaxWidthDays(maxDays) {
      for (let i = 0; i < maxDays; i += 1) {
        let rectangle = new Graphics();
        rectangle.lineStyle(2, 0x434343, 0.4);
        rectangle.beginFill(0xffffff, 0.88);
        rectangle.drawRoundedRect(0, 0, this.xStepSize * i, this.yStepSize, 20);
        rectangle.endFill();
        const texture = this.app.renderer.generateTexture(rectangle);
        this.bookingTexturePool.push(texture);
      }
    },
    pregenerateSpriteAndText(maxElements) {
      for (let i = 0; i < maxElements; i += 1) {
        const bookingSprite = new Sprite(this.bookingTexturePool[0]);
        // bookingSprite.alpha = 0.88;
        // make the sprite interactive
        bookingSprite.interactive = true;
        bookingSprite.buttonMode = true;
        bookingSprite.on('mousedown', () => {
          this.clickOnExistingBooking = true;
          // this.menuMode = status.uuid;
        });
        bookingSprite.on('mouseover', (e) => {
          this.detectBookingCollision(e, this.showMenu ? 'mouseMove' : undefined);
        });
        bookingSprite.on('mouseup', () => {
          this.clickOnExistingBooking = true;
          // this.menuMode = status.uuid;
        });
        bookingSprite.on('touchend', this.openMenuWithTouch);
        bookingSprite.x = -5000;
        bookingSprite.y = -5000;

        const bookingText = new BitmapText('???', {fontName: 'fontArial16', align: 'center'});
        bookingText.anchor.set(0.5, 0.5);
        bookingText.position.set(-5000, -5000);

        const element = {
          spriteElement: bookingSprite,
          textElement: bookingText
        }

        this.bookingContainer.addChild(bookingSprite);
        this.bookingContainer.addChild(bookingText);
        this.bookingSpriteAndTextPool.push(element);
      }
    },
    throttleUpdate () {               // We return a throttled function
      if (this.timeout) clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
        this.updateCalculation();
      }, 250);
    },
    updateCalculation () {
      this.$nextTick(async function () {
        // DOM needs to be updated
        // so that changes to the optional booking extra count
        // are as well already updated and then used for the next calculcation
        if (!this.newBooking || !this.newBooking.startDate || !this.newBooking.endDate || !this.rentObject || !this.rentObject.rentObjectPrices) return;
        const calculation = await this.$store.dispatch("rentObjectBookings/calculatePrice", {
          bookingId: 0, // new booking
          rentObjectId: this.rentObject.id,
          startDate: this.newBooking.startDate,
          endDate: this.newBooking.endDate,
          bookingExtraItems: undefined,
          persons: 1
        });
        this.bookingAllowed = calculation.bookingAllowed;
        this.drawNewBooking();
        this.$store.commit("rentObjectBookings/setNewBookingCalculation", calculation);
      })
    },
    detectQueryParameters() {
      if (this.$route.query.jumpObjectId) {
        const r = this.searchResults.findIndex(s => s.id.toString() === this.$route.query.jumpObjectId.toString());
        if (r >= 0) {
          this.yOffsetScroll = r;
          this.resizeEvent();
        }
        this.$route.query.jumpObjectId = undefined;
      }
      if (this.$route.query.jumpDate) {
        this.currentDate = DateTime.fromHTTP(this.$route.query.jumpDate).minus({days: xStepSizeWidthCount}).set({hours: 18}).toJSDate();
        this.$route.query.jumpDate = undefined;
        this.resizeEvent();
      }
    },
    refreshInbox() {
      this.$root.$emit('reloadCalendar');
    },
    updateBookingData(data) {
      for (let x = 0; x < this.searchResults.length; x += 1) {
        const bookings = this.searchResults[x].rentObjectBookings;
        for (let y = 0; y < bookings.length; y += 1) {
          if (bookings[y].id === data.id) {
            this.$set(bookings, y, data);
            this.drawBookings();
            this.jumpToBooking(data);
            break;
          }
        }
      }
    },
    openMenuWithTouch(e) {
      this.detectBookingCollision(e);
      this.mouseClickPos = {x: e.data.global.x, y: e.data.global.y};
      this.showMenu = true;
    },
    async mouseDown(e) {
      // Here we get the mouse position
      // and locate the active cell
      const mousePos = {x: e.offsetX, y: e.offsetY};
      const activeCell = {x: Math.floor(mousePos.x/this.xStepSize), y: Math.floor((mousePos.y)/this.yStepSize)-2};
      const mouseDate = this.detectBookingCollision(e);
      // Here we reset all values
      this.mouseMode = 'down';
      this.mouseMoved = false;

      // In case the open the menu
      // this will be the position of the menu
      if (this.clickOnNewBooking || this.clickOnExistingBooking) {
        if (e.offsetX) {
          this.mouseClickPos = {x: e.offsetX, y: e.offsetY};
        } else if (e.data) {
          this.mouseClickPos = {x: e.data.global.x, y: e.data.global.y};
        }
      }
      
      // Ostimistically we already fetch the rentObject data
      // and start the new Booking startDate
      const yResult = this.searchResults[activeCell.y + this.yOffsetScroll];
      if (this.clickOnNewBooking && this.newBooking.startDate && this.newBooking.endDate) {
        // We just open the menu
        this.mouseMode = null;
      } else if ((yResult && this.showMenu === false) || (yResult && this.clickOnExistingBooking && !this.clickOnNewBooking)) {
        // In case we already touched an existing booking
        // We optimistically fetch the new data
        if (this.hitBookings[0] && this.hitBookings[0].id) {
          this.$store.dispatch("rentObjectBookings/findByIdForBookingCalendar", {id: this.hitBookings[0].id});
        }

        this.$store.dispatch("rentObjects/findByIdForBookingCalendar", {id: yResult.id});
        this.newBooking = {
          rentObjectId: yResult.id,
          startDate: mouseDate.set({ hour: 15 }),
          endDate: null
        };
        // this.$store.commit("rentObjectBookings/setSearchAndFilterMode", 'search');
        this.drawNewBooking();
      }

      // And here we reset the clicks on the new booking and 
      this.clickOnNewBooking = false;
      this.clickOnExistingBooking = false;
    },
    mouseMove(e) {
      let mouseDate = this.detectBookingCollision(e, this.showMenu ? 'mouseMove' : undefined);
      if (this.mouseMode === 'down' && this.showMenu === false) {
        if (this.newBooking.startDate && (this.newBooking.startDate.startOf('day') < mouseDate.startOf('day')) ) {
          this.mouseMoved = true;
          this.bookingAllowed = true;
          this.newBooking.endDate = mouseDate.set({ hour: 10 });
          this.$store.commit("rentObjectBookings/setSearchAndFilterMode", 'new');
          this.drawNewBooking();
          this.throttleUpdate();
        }
      }

      // we need this for tooltip purposes
      // const rect = document.getElementById('canvas-wrapper').getBoundingClientRect();
      if (e.offsetX) {
        this.mousePos = {x: e.offsetX, y: e.offsetY};
      } else if (e.data) {
        this.mousePos = {x: e.data.global.x, y: e.data.global.y};
      }
    },
    mouseUp(e) {
      // In case the open the menu
      // this will be the position of the menu
      if (e.offsetX) {
        this.mouseClickPos = {x: e.offsetX, y: e.offsetY};
      } else if (e.data) {
        this.mouseClickPos = {x: e.data.global.x, y: e.data.global.y};
      }

      // Ok here we clicked on existing bookings
      if (this.clickOnExistingBooking && (!this.newBooking.endDate || this.newBooking.startDate.startOf('day').toISODate() === this.newBooking.endDate.endOf('day').toISODate())) {
        // Mode is set directly on the booking drawing function
        // We switch the search and filter mode to show the booking information
        this.showMenu = true;
        this.$store.commit("rentObjectBookings/setSearchAndFilterMode", 'existing');
      } else if (this.clickOnNewBooking && !this.mouseMoved) {
        this.menuMode = "new";
        this.showMenu = true;
      }

      if (!this.newBooking.endDate) {
        this.newBooking = {
          rentObjectId: null,
          startDate: null,
          endDate: null
        };
        if (!this.clickOnExistingBooking) {
          this.$store.commit("rentObjectBookings/setSearchAndFilterMode", 'search');
        }
      }

      if (!this.clickOnNewBooking && !this.clickOnExistingBooking) {
        this.showMenu = false;
      }

      // Here we rest the mouse and clicks
      this.clickOnNewBooking = false;
      this.clickOnExistingBooking = false;

      this.mouseMode = null;
      this.mouseMoved = false;
      this.drawNewBooking();
    },
    detectBookingCollision(e, mouseMove) {
      let mousePos = null;
      const rect = document.getElementById('canvas-wrapper').getBoundingClientRect();
      if (e.offsetX) {
        mousePos = {x: e.offsetX, y: e.offsetY};
      } else if (e.data) {
        mousePos = {x: e.data.global.x, y: e.data.global.y};
      } else {
        mousePos = {x: e.screenX - rect.left, y: e.screenY - 320};
      }

      const activeCell = {x: Math.floor(mousePos.x/this.xStepSize), y: Math.floor((mousePos.y)/this.yStepSize)-2 + this.yOffsetScroll};
      const mouseDate = DateTime.fromJSDate(this.currentDate.addDays(activeCell.x));

      // When the menu is open the selection of bookings should be stabel
      if (mouseMove) return mouseDate;

      this.hitBookings = [];
      if (activeCell.y < 0 || this.searchResults.length <= activeCell.y) {
        return mouseDate;
      }
      
      for (let b = 0; b < this.searchResults[activeCell.y].rentObjectBookings.length; b += 1) {
        const booking = this.searchResults[activeCell.y].rentObjectBookings[b];
        const bookingEnd = this.dateDiff(this.currentDate, booking.endDate);
        const bookingStart = this.dateDiff(this.currentDate, booking.startDate);

        if (bookingStart <= activeCell.x && activeCell.x <= bookingEnd ) {
          // This way we can display the same within the contract modal ;D
          booking.rentObject = {
            id: this.searchResults[activeCell.y].id,
            name: this.searchResults[activeCell.y].name,
          }
          const status = this.bookingStatus.find(b => b.id === booking.bookingStatusId);
          this.menuMode = status.uuid;
          this.hitBookings.push(booking);
        }
      }
      return mouseDate;
    },
    destroyNewBooking() {
      if (this.newBookingObj.rectangle) {
        this.newBookingObj.rectangle.destroy();
        this.newBookingObj.rectangle = null;
      }
      if (this.newBookingObj.text) {
        this.newBookingObj.text.destroy();
        this.newBookingObj.text = null;
      }
    },
    drawNewBooking() {
      this.destroyNewBooking();

      if (!this.newBooking.startDate || !this.newBooking.endDate) {
        return;
      }

      const widthDays = this.dateDiff(this.newBooking.startDate, this.newBooking.endDate);
      const widthStart = this.dateDiff(this.currentDate, this.newBooking.startDate);
      const i =  this.searchResults.findIndex(s => s.id === this.newBooking.rentObjectId) - this.yOffsetScroll;

      if (i < 0) return;

      let rectangle = new Graphics();
      rectangle.beginFill(this.bookingAllowed ? 0x2e3cb4 : 0x991B1B);
      rectangle.drawRoundedRect(0, 0, this.xStepSize * widthDays, this.yStepSize, 999);
      rectangle.endFill();
      rectangle.interactive = true;
      rectangle.hitArea = rectangle.getBounds();
      rectangle.x = this.xStepSize * widthStart + this.xStepSize/2;
      rectangle.y = (this.yStepSize*i) + this.topLabelHeight;
      rectangle.on('mousedown', () => this.clickOnNewBooking = true);
      rectangle.on('mouseup', () => this.clickOnNewBooking = true);

      const text = new BitmapText(`${widthDays} ${widthDays > 1 ? 'Tage' : 'Tag'}`, {fontName: 'whiteFontArial16', align: "center", fill: 'white'});
      // const text = new BitmapText(`123456 Sebastian ZiemlichCoolKlein`, {fontName: 'fontArial', align: "center"})
      text.maxWidth = this.xStepSize * widthDays;
      text.anchor.set(0.5, 0.5);
      text.position.set(this.xStepSize * widthStart + this.xStepSize/2 + (this.xStepSize * widthDays / 2), (this.yStepSize*i) + this.topLabelHeight+20);

      this.newBookingContainer.addChild(rectangle);
      this.newBookingContainer.addChild(text);
      this.newBookingObj.rectangle = rectangle;
      this.newBookingObj.text = text;
    },
    getUUIDFromId(id) {
      const status = this.bookingStatus.find(b => b.id === id);
      return status.uuid;
    },
    dateDiff(a, b) {
      const start = Date.parse(a);
      const end = Date.parse(b);
      const past = start <= end ? 1 : -1;
      const diffTime = Math.abs(end - start);
      return Math.ceil(diffTime / (1000 * 60 * 60 * 24 * past)); 
    },
    destroyRentObjects() {
      for (let i = 0; i < this.rentObjects.length; i += 1) {
        this.rentObjects[i].rectangle.destroy();
        this.rentObjects[i].text.destroy();
      }
      this.rentObjects = []
    },
    async checkTimeFrame() {
      const dayWidth = Math.floor(this.width / this.xStepSize);
      const currentEndDate = DateTime.fromJSDate(this.currentDate).plus({days: dayWidth}).toJSDate();
      const startDate = DateTime.fromJSDate(this.currentDate).minus({days: this.NEW_TIMEFRAME_THRESHOLD}).toJSDate();
      const endDate = DateTime.fromJSDate(this.currentDate).plus({days: dayWidth + this.NEW_TIMEFRAME_THRESHOLD}).toJSDate();
      const startDateBuffer = DateTime.fromJSDate(this.currentDate).minus({days: this.TIMEFRAME_BUFFER}).toJSDate();
      const endDateBuffer = DateTime.fromJSDate(this.currentDate).plus({days: dayWidth + this.TIMEFRAME_BUFFER}).toJSDate();

      if (this.currentDate < this.timeframe.startDate ||  this.timeframe.endDate < currentEndDate) {
        this.$root.$emit('setNewTimeframe', {
          startDate: startDateBuffer,
          endDate: endDateBuffer,
        });
        this.timeframe = {
          startDate,
          endDate,
        }
        this.holidays = await this.$store.dispatch('holidays/findBetweenRange', {startDate: startDateBuffer, endDate: endDateBuffer})
        this.loopThroughDays(); // Otherwise holidays are not shown when not scrolled
      }
    },
    resetBookingLocations(startIndex) {
      for (let i = startIndex; i < this.bookingSpriteAndTextPool.length; i += 1) {
        if (this.bookingSpriteAndTextPool[i].spriteElement.y < -1000) break; // this means we reached the end of used bookings
        this.bookingSpriteAndTextPool[i].spriteElement.x = -5000;
        this.bookingSpriteAndTextPool[i].spriteElement.y = -5000;
        this.bookingSpriteAndTextPool[i].textElement.x = -5000;
        this.bookingSpriteAndTextPool[i].textElement.y = -5000;
      }
    },
    drawBookings() {
      this.checkTimeFrame();
      let bookingCounter = 0;
      if (!this.bookingSpriteAndTextPool[bookingCounter]) return;

      for (let i = 0; i < this.searchResults.length; i += 1) {
        if (!this.searchResults[i + this.yOffsetScroll]) continue;
        if (bookingCounter >= this.MAX_DISPLAY_BOOKINGS) {
          break;  
        }

        // Optimization: We only draw bookings when the rentObject is visbible
        const maxRowCount = Math.floor(this.height / this.yStepSize);
        if (i > maxRowCount) {
          break;
        }

        for (let b = 0; b < this.searchResults[i + this.yOffsetScroll].rentObjectBookings.length; b += 1) {
          if (bookingCounter >= this.MAX_DISPLAY_BOOKINGS) {
            alert(`Es gibt mehr als ${this.MAX_DISPLAY_BOOKINGS} Buchungen. Bitte aktivieren Sie mehr Filter, um alle Buchungen zu sehen.`);
            break;  
          }

          const booking = this.searchResults[i + this.yOffsetScroll].rentObjectBookings[b];
          const widthDays = this.dateDiff(booking.startDate, booking.endDate);
          const widthStart = this.dateDiff(this.currentDate, booking.startDate);

          const status = this.bookingStatus.find(b => b.id === booking.bookingStatusId);
          const commission = this.commissions.find(c => c.id == booking.commissionId);
 
          let modText;
          if (status.uuid === 'STATUS_BOOKING_PERSONAL') {
            this.searchResults[i + this.yOffsetScroll].rentObjectBookings[b].owner = this.searchResults[i + this.yOffsetScroll].owner;
            modText = `${this.searchResults[i + this.yOffsetScroll].owner.fullName}`;
          } else if (status.uuid === 'STATUS_BOOKING_BLOCKED') {
            modText = `${booking.comment ? booking.comment : ''}`;
          } else if (status.uuid === 'STATUS_BOOKING_INTERNET') {
            modText = `${booking.customer.title ? booking.customer.title+' ' : ''}${booking.customer.lastName}${booking.customer.firstName ? ', ' + booking.customer.firstName : ''}`;
          } else if (status.uuid === 'STATUS_BOOKING_OFFER' && booking.offers.length > 0) {
            modText = `${commission.uuid === 'COMMISSION_OWNER' ? 'ET-' : ''}${booking.offers[booking.offers.length-1].id} ${booking.customer.title ? booking.customer.title+' ' : ''}${booking.customer.lastName}${booking.customer.firstName ? ', ' + booking.customer.firstName : ''}`;
          } else if (['STATUS_CONTRACT_SENT', 'STATUS_CONTRACT_RECEIVED'].includes(status.uuid)) {
            modText = `${commission.uuid === 'COMMISSION_OWNER' ? 'ET-' : ''}${booking.parentContractId? booking.parentContractId : '???'} ${booking.customer.title ? booking.customer.title+' ' : ''}${booking.customer.lastName}${booking.customer.firstName ? ', ' + booking.customer.firstName : ''}`;
          } else {
            modText = `${commission.uuid === 'COMMISSION_OWNER' ? 'ET-' : ''}${booking.customer.title ? booking.customer.title+' ' : ''}${booking.customer.lastName}${booking.customer.firstName ? ', ' + booking.customer.firstName : ''}`;
          }

          if (widthDays === 1) {
            modText = modText.substring(0, 2);
          } else if (widthDays === 2) {
            modText = modText.substring(0, 3);
          } else if (widthDays === 3) {
            modText = modText.substring(0, 3);
          } else if (widthDays >= 4 && modText.length > widthDays*2) {
            modText = modText.substring(0, Math.ceil(widthDays*2.5));
          }

          this.bookingSpriteAndTextPool[bookingCounter].spriteElement.texture = this.bookingTexturePool[widthDays];
          this.bookingSpriteAndTextPool[bookingCounter].spriteElement.tint = utils.string2hex(status.colorCode);
          this.bookingSpriteAndTextPool[bookingCounter].spriteElement.x = this.xStepSize * widthStart + this.xStepSize/2;
          this.bookingSpriteAndTextPool[bookingCounter].spriteElement.y = (this.yStepSize*i) + this.topLabelHeight;
          this.bookingSpriteAndTextPool[bookingCounter].textElement.x = this.xStepSize * widthStart + this.xStepSize/2 + (this.xStepSize * widthDays / 2);
          this.bookingSpriteAndTextPool[bookingCounter].textElement.y = (this.yStepSize*i) + this.topLabelHeight+20;
          this.bookingSpriteAndTextPool[bookingCounter].textElement.text = modText;

          bookingCounter += 1;
        }
      }
      this.resetBookingLocations(bookingCounter);
      // For debugging purposes
      // console.log(bookingCounter);
    },
    destroyOffers() {
      for (let i = 0; i < this.offers.length; i += 1) {
        this.offers[i].rectangle.destroy();
        this.offers[i].text.destroy();
      }
      this.offers = []
    },
    drawOffers() {
      this.destroyOffers();
      for (let i = 0; i < this.selectedOffersSortedByRentObjects.length; i += 1) {
        if (!this.selectedOffersSortedByRentObjects[i + this.yOffsetScroll]) continue;
        for (let b = 0; b < this.selectedOffersSortedByRentObjects[i + this.yOffsetScroll].rentObjectBookings.length; b += 1) {
          const booking = this.selectedOffersSortedByRentObjects[i + this.yOffsetScroll].rentObjectBookings[b];
          const widthDays = this.dateDiff(booking.startDate, booking.endDate);
          const widthStart = this.dateDiff(this.currentDate, booking.startDate);

          let rectangle = new Graphics();
          rectangle.lineStyle(1, 0x434343, 1);
          rectangle.beginFill(0xC1FFFF);
          rectangle.drawRoundedRect(0, 0, this.xStepSize * widthDays, this.yStepSize, 999);
          rectangle.endFill();
          rectangle.interactive = true;
          rectangle.hitArea = rectangle.getBounds();
          rectangle.x = this.xStepSize * widthStart + this.xStepSize/2;
          rectangle.y = (this.yStepSize*i) + this.topLabelHeight;
          rectangle.alpha = 0.8;

          let modText = `Angebot ${booking.nr}`;

          if (widthDays === 1) {
            modText = modText.substring(0, 2);
          } else if (widthDays === 2) {
            modText = modText.substring(0, 3);
          } else if (widthDays === 3) {
            modText = modText.substring(0, 3);
          } else if (widthDays >= 4 && modText.length > widthDays*2) {
            modText = modText.substring(0, widthDays*2);
          }

          const text = new BitmapText(modText, {fontName: 'fontArial16', align: 'center'})

          // const text = new BitmapText(`123456 Sebastian ZiemlichCoolKlein`, {fontName: 'fontArial', align: "center"})
          text.maxWidth = this.xStepSize * widthDays;
          text.anchor.set(0.5, 0.5);
          text.position.set(this.xStepSize * widthStart + this.xStepSize/2 + (this.xStepSize * widthDays / 2), (this.yStepSize*i) + this.topLabelHeight+20);

          this.app.stage.addChild(rectangle);
          this.app.stage.addChild(text);
          this.offers.push({rectangle, text});
        }
      }
    },
    initRentObjects() {
      this.destroyRentObjects();
      const maxRowCount = Math.floor(this.height / this.yStepSize);
      for (let i = 0; i < this.searchResults.length; i += 1) {
        if (maxRowCount < i) break;
        let text;
        let rectangle = new Graphics();

        if (this.searchResults[this.yOffsetScroll + i]) {
          const rentObjectType = this.rentObjectTypes.find(r => r.id === this.searchResults[this.yOffsetScroll + i].rentObjectTypeId);
          if (!rentObjectType) return;
          rectangle.lineStyle(1.1, 0x64748b, 0.56);
          rectangle.beginFill(utils.string2hex(rentObjectType.colorCode));
          rectangle.drawRect(0, 0, this.xStepSize * this.xStepSizeWidthCount, this.yStepSize);
          rectangle.endFill();
          rectangle.x = 0;
          rectangle.y = this.yStepSize*i + this.topLabelHeight;
          rectangle.interactive = true;
          rectangle.buttonMode = false;

          let modText = `${this.searchResults[this.yOffsetScroll + i].code} ${this.searchResults[this.yOffsetScroll + i].name}`;
          modText = modText.substring(0, 40);
          text = new BitmapText(modText, {fontName: 'fontArial16'});

          text.maxWidth = this.xStepSize * this.xStepSizeWidthCount;
          text.position.set(this.xStepSize/2, this.yStepSize*i+this.xStepSizeWidthCount+this.topLabelHeight);
        } else {
          rectangle.y = this.yStepSize*i + this.topLabelHeight;
          text = new BitmapText('', {fontName: 'fontArial16'});
          text.maxWidth = this.xStepSize * this.xStepSizeWidthCount;
          text.position.set(this.xStepSize/2, this.yStepSize*i+this.xStepSizeWidthCount+this.topLabelHeight);
        }
        this.rentObjectContainer.addChild(rectangle);
        this.rentObjectContainer.addChild(text);
        this.rentObjects.push({rectangle, text});
      }
    },
    drawRentObjects() {
      for (let i = 0; i < this.rentObjects.length; i += 1) {
        if (this.searchResults[this.yOffsetScroll + i]) {
          this.rentObjects[i].rectangle.clear();
          const rentObjectType = this.rentObjectTypes.find(r => r.id === this.searchResults[this.yOffsetScroll + i].rentObjectTypeId);
          this.rentObjects[i].rectangle.lineStyle(1.1, 0x64748b, 0.56);
          this.rentObjects[i].rectangle.beginFill(utils.string2hex(rentObjectType.colorCode));
          this.rentObjects[i].rectangle.drawRect(0, 0, this.xStepSize * this.xStepSizeWidthCount, this.yStepSize);
          this.rentObjects[i].rectangle.endFill();

          let modText = `${this.searchResults[this.yOffsetScroll + i].code} ${this.searchResults[this.yOffsetScroll + i].name}`;
          modText = modText.substring(0, 40);
          this.rentObjects[i].text.text = modText;
        } else {
          this.rentObjects[i].rectangle.clear();
          this.rentObjects[i].text.text = '';
        }
      }
    },
    destroyWeekLabels() {
      for (let i = 0; i < this.weekLabels.length; i += 1) {
        this.weekLabels[i].rectangle.destroy();
        this.weekLabels[i].text.destroy();
      }
      this.weekLabels = [];
    },
    destroyMonthLabels() {
      for (let i = 0; i < this.monthLabels.length; i += 1) {
        this.monthLabels[i].rectangle.destroy();
        this.monthLabels[i].text.destroy();
      }
      this.monthLabels = [];
    },
    destroyDayLabels() {
      for (let i = 0; i < this.weekdayLabels.length; i += 1) {
        this.weekdayLabels[i].destroy();
        this.dayLabels[i].destroy();
      }
      this.weekdayLabels = [];
      this.dayLabels = []
    },
    initDayLabels() {
      const xSteps = this.width / this.xStepSize;
      for (let i = 0; i < xSteps; i += 1) {
        const x = this.xStepSize * i;

        const weekday = new BitmapText('', {fontName: 'fontArial'})
        weekday.anchor.set(0.5, 0.5);
        weekday.position.set(x+this.xStepSize/2, 50, '');
        
        const day = new BitmapText('', {fontName: 'fontArialBold'})
        day.anchor.set(0.5, 0.5);
        day.position.set(x+this.xStepSize/2, 70, '');
        day.interactive = true;
        day.on('mouseout', () => {
          this.matchedHolidays = [];
        });
        
        this.weekdayLabels.push(weekday);
        this.dayLabels.push(day);

        this.app.stage.addChild(weekday);
        this.app.stage.addChild(day);
      }
    },
    initWeekLabels() {
      const xSteps = this.width / this.xStepSize;
      const weekCount = xSteps / 7 + 1;
      for (let i = 0; i < weekCount; i += 1) {        
        let rectangle = new Graphics();
        rectangle.lineStyle(1, 0x64748b, 1);
        rectangle.beginFill(0xf1f5f9);
        rectangle.drawRect(0, 0, 250, 20);
        rectangle.endFill();
        rectangle.x = -1000;
        rectangle.y = 20;

        const text = new BitmapText('', {fontName: 'fontArial'})
        // let text = new Text('', this.textStyle);
        text.anchor.set(0.5, 0.5);
        text.position.set(0, 30);
        this.weekLabels.push({rectangle, text});
        this.app.stage.addChild(rectangle);
        this.app.stage.addChild(text);
      }
    },
    initMonthLabels() {
      const xSteps = this.width / this.xStepSize;
      const monthCount = xSteps / 30 + 1;
      for (let i = 0; i < monthCount; i += 1) {
        let rectangle = new Graphics();
        rectangle.lineStyle(1, 0x64748b, 1);
        rectangle.beginFill(0xf1f5f9);
        rectangle.drawRect(0, 0, 1500, 20);
        rectangle.endFill();
        rectangle.x = -1000;
        rectangle.y = 0;

        const text = new BitmapText('', {fontName: 'fontArialBold'})
        text.anchor.set(0.5, 0.5);
        text.position.set(0, 10);
        this.monthLabels.push({rectangle, text});
        this.app.stage.addChild(rectangle);
        this.app.stage.addChild(text);
      }
    },
    drawActiveCell(x,y) {
      this.hoverCell ? this.hoverCell.clear() : null;
      this.hoverCell = new Graphics();
      this.hoverCell.beginFill(0xbecde0);
      this.hoverCell.drawRect(0, 0, this.xStepSize, this.yStepSize);
      this.hoverCell.endFill();
      this.hoverCell.x = x;
      this.hoverCell.y = y;
      this.app.stage.addChild(this.hoverCell);
    },
    destroyGrid() {
      for (let i = 0; i < this.xGrid.length; i += 1) {
        this.xGrid[i].destroy();
      }
      for (let i = 0; i < this.yGrid.length; i += 1) {
        this.yGrid[i].destroy();
      }
      this.xGrid = [];
      this.yGrid = [];
    },
    drawHorizontalLine(x, y) {
      let line = new Graphics();
      line.lineStyle(1.1, 0x64748b, 0.56);
      line.moveTo(0, 0);
      line.lineTo(this.width, 0);
      line.x = x;
      line.y = y;
      this.yGrid.push(line);
      this.app.stage.addChild(line);
    },
    initGrid() {
      this.destroyGrid();
      const xSteps = this.width / this.xStepSize;
      const ySteps = (this.height-this.topLabelHeight) / this.yStepSize;
      for (let i = 0; i < xSteps; i += 1) {
        const d = this.currentDate.addDays(i);
        const x = this.xStepSize * i;

        let rectangle = new Graphics();
        rectangle.lineStyle(1.1, 0x64748b, 0.56);
        rectangle.beginFill(d.getDay() === 0 || d.getDay() === 6 ? 0xf1f5f9 : 0xffffff);
        rectangle.drawRect(0, 0, this.xStepSize, this.height-this.topLabelHeight);
        rectangle.endFill();
        rectangle.x = x;
        rectangle.y = this.topLabelHeight;

        this.app.stage.addChild(rectangle);
        this.xGrid.push(rectangle);
      }
      for (let i = 0; i < ySteps; i += 1) {
        const y = this.yStepSize * i;
        this.drawHorizontalLine(0, y + this.topLabelHeight);
      }
      const yTopSteps = this.topLabelHeight / 4;
      for (let i = 0; i < 4; i += 1) {
        const y = yTopSteps * i;
        this.drawHorizontalLine(0, y);
      }
    },
    drawxGridHighlights() {
      for (let i = 0; i < this.xGrid.length; i += 1) {
        this.xGrid[i].clear();
        const d = this.currentDate.addDays(i);
        const x = this.xStepSize * i;

        this.xGrid[i].lineStyle(1, 0x64748b, 1);
        if (this.highlightRange && this.highlightRange.startDate && this.highlightRange.endDate && this.highlightRange.startDate.addDays(-1) < d && d < this.highlightRange.endDate.addDays(1)) {
          this.xGrid[i].beginFill(utils.string2hex(this.settings.colorCodeDateRange));
        } else if (d.getDay() === 6) {
          this.xGrid[i].beginFill(utils.string2hex(this.settings.colorCodeSaturday));
        } else if (d.getDay() === 0) {
          this.xGrid[i].beginFill(utils.string2hex(this.settings.colorCodeSunday));
        } else {
          this.xGrid[i].beginFill(0xffffff);
        }
        this.xGrid[i].drawRect(0, 0, this.xStepSize, this.height-this.topLabelHeight);
        this.xGrid[i].endFill();
        this.xGrid[i].x = x;
      }
    },
    drawHighlightDay() {
      if (this.highlightDay.rectangle) {
        this.highlightDay.rectangle.clear();
      } else {
        this.highlightDay.rectangle = new Graphics();
      }
      const diffDays = this.dateDiff(this.currentDate, this.highlightDay.date) - 1;
      const x = this.xStepSize * diffDays;

      this.highlightDay.rectangle.lineStyle(1, 0x64748b, 1);
      this.highlightDay.rectangle.beginFill(utils.string2hex(this.settings.colorCodeToday));
      this.highlightDay.rectangle.drawRect(0, 0, this.xStepSize, this.height-this.topLabelHeight);
      this.highlightDay.rectangle.endFill();
      this.highlightDay.rectangle.x = x;
      this.highlightDay.rectangle.y = this.topLabelHeight;
      this.app.stage.addChild(this.highlightDay.rectangle);
    },
    drawUI() {
      this.initGrid();
      this.drawxGridHighlights();
      this.drawHighlightDay();
      this.initElements();
      this.loopThroughDays();
      this.drawBookings();
      this.drawOffers();
      this.initRentObjects();
    },
    resizeEvent() {
      if (!this.app.stage) return;

      this.app.stage.removeChildren();
      this.app.stage.addChild(this.rentObjectContainer);
      this.app.stage.addChild(this.bookingContainer);
      this.app.stage.addChild(this.newBookingContainer);
      this.height = window.innerHeight - 180 - 80;
      this.width = window.innerWidth;
      this.app.renderer.resize(this.width, this.height);
      this.initElements()
      this.initGrid();
      this.drawxGridHighlights();
      this.drawHighlightDay();
      this.loopThroughDays();
      this.drawBookings();
      this.drawOffers();
      this.initRentObjects();
      this.drawRentObjects();
    },
    destroyAllElements() {
      this.destroyDayLabels();
      this.destroyWeekLabels();
      this.destroyMonthLabels();
    },
    initElements() {
      this.destroyAllElements();

      this.initDayLabels();
      this.initWeekLabels();
      this.initMonthLabels();
    },
    matchesHolidays(d) {
      return this.holidays.filter(h => new Date(h.date).getDate() === d.getDate() && new Date(h.date).getMonth() === d.getMonth())
    },
    loopThroughDays() {
      const weeks = [];
      const months = [];
      let previousDate = this.currentDate;
      let weekObj = {
        start: 0,
        end: null,
        msg: ''
      }
      let monthObj = {
        start: 0,
        end: null,
        msg: ''
      }
      const xSteps = this.width / this.xStepSize;
      for (let i = 0; i < xSteps; i += 1) {
        const d = this.currentDate.addDays(i);

        // DAY & WEEKDAY
        this.weekdayLabels[i].text = this.weekdays[d.getDay()];
        this.dayLabels[i].text = d.getDate();
        
        // Here we make the holiday detection
        const matchedHolidays = this.matchesHolidays(d);
        if (matchedHolidays.length > 0) {
          this.dayLabels[i].fontName = 'fontArialBoldWhite';
          this.dayLabels[i].tint = 0xe91e63;
          this.dayLabels[i].on('mouseover', () => {
            this.matchedHolidays = matchedHolidays;
          });
        } else {
          this.dayLabels[i].fontName = 'fontArialBold';
          this.dayLabels[i].on('mouseover', () => {
            this.matchedHolidays = [];
          });
        }

        // WEEK-NUMBER
        if (d.getWeek() != previousDate.getWeek() && i !== 0) {
          weekObj.end = i*this.xStepSize;
          weekObj.msg = previousDate.getWeek() + ' KW';
          weeks.push({...weekObj});
          weekObj.start = weekObj.end;
          weekObj.end = null;
        }

        // MONTH
        if (d.getMonth() != previousDate.getMonth() && i !== 0) {
          monthObj.end = i*this.xStepSize;
          monthObj.msg = this.monthName[previousDate.getMonth()] + ' ' + previousDate.getFullYear();
          months.push({...monthObj});
          monthObj.start = monthObj.end;
          monthObj.end = null;
        }

        previousDate = d;
      }

      // After the lopp we need to add the last item
      // WEEK-NUMBER
      weekObj.end = this.width;
      weekObj.msg = previousDate.getWeek() + ' KW';
      weeks.push({...weekObj});

      for (let i = 0; i < this.weekLabels.length; i += 1) {
        this.weekLabels[i].rectangle.clear();
        if (!weeks[i]) {
          this.weekLabels[i].rectangle.x = -10000;
          this.weekLabels[i].text.position.set(-10000, 30);
          break;
        }

        this.weekLabels[i].rectangle.lineStyle(1, 0x64748b, 1);
        this.weekLabels[i].rectangle.beginFill(0xf1f5f9);
        this.weekLabels[i].rectangle.drawRect(0, 0, weeks[i].end - weeks[i].start, 20);
        this.weekLabels[i].rectangle.endFill();
        this.weekLabels[i].rectangle.x = weeks[i].start;
        this.weekLabels[i].text.text = weeks[i].msg;
        this.weekLabels[i].text.position.set((weeks[i].end + weeks[i].start)/2, 30);
      }

      // MONTH
      monthObj.end = this.width;
      monthObj.msg = this.monthName[previousDate.getMonth()] + ' ' + previousDate.getFullYear();
      months.push({...monthObj});

      for (let i = 0; i < this.monthLabels.length; i += 1) {
        this.monthLabels[i].rectangle.clear();
        if (!months[i]) {
          this.monthLabels[i].rectangle.x = -10000;
          this.monthLabels[i].text.position.set(-10000, 10);
          break;
        }

        this.monthLabels[i].rectangle.lineStyle(1, 0x64748b, 1);
        this.monthLabels[i].rectangle.beginFill(0xf1f5f9);
        this.monthLabels[i].rectangle.drawRect(0, 0, months[i].end - months[i].start, 20);
        this.monthLabels[i].rectangle.endFill();
        this.monthLabels[i].rectangle.x = months[i].start;
        this.monthLabels[i].text.text = months[i].msg;
        this.monthLabels[i].text.position.set((months[i].end + months[i].start)/2, 10);
      }
    },
    scrollEvent(e) {
      if (e.type === "touchmove") {
        // Get the current touch position
        const currentX = e.touches[0].clientX;
        const currentY = e.touches[0].clientY;

        // Get the previous touch position from the touchstart or previous touchmove event
        const previousX = this.previousTouchX || currentX;
        const previousY = this.previousTouchY || currentY;

        // Calculate the deltaX and deltaY values
        const deltaX = currentX - previousX;
        const deltaY = currentY - previousY;
        this.xScrollVelocity -= deltaX/10;
        this.yScrollVelocity -= deltaY/10;

        // Store the current touch position for the next touchmove event
        this.previousTouchX = currentX;
        this.previousTouchY = currentY;
      } else {
        this.xScrollVelocity += e.deltaX/10;
        this.yScrollVelocity += e.deltaY/10;
      }
      if (this.xScrollVelocity > 1) {
        this.xScrollVelocity = 0;
        this.currentDate = this.currentDate.addDays(3)
        this.loopThroughDays();
        this.drawxGridHighlights();
        this.drawHighlightDay();
        this.drawBookings();
        this.drawOffers();
        this.drawRentObjects();
        this.drawNewBooking();
      } else if (this.xScrollVelocity < -1) {
        this.xScrollVelocity = 0;
        this.currentDate = this.currentDate.addDays(-3)
        this.loopThroughDays();
        this.drawxGridHighlights();
        this.drawHighlightDay();
        this.drawBookings();
        this.drawOffers();
        this.drawRentObjects();
        this.drawNewBooking();
      }
      if (this.yScrollVelocity > 1) {
        this.yScrollVelocity = 0;
        this.yOffsetScroll += 1;
        if (this.yOffsetScroll >= this.searchResults.length) this.yOffsetScroll = this.searchResults.length - 1;
        this.drawBookings();
        this.drawOffers();
        this.drawRentObjects();
        this.drawNewBooking();
      } else if (this.yScrollVelocity < -1) {
        this.yScrollVelocity = 0;
        this.yOffsetScroll -= 1;
        if (this.yOffsetScroll < 0) this.yOffsetScroll = 0;
        this.drawBookings();
        this.drawOffers();
        this.drawRentObjects();
        this.drawNewBooking();
      }
    },
    addOffer(offer) {
      this.newBooking = {
        rentObjectId: null,
        startDate: null,
        endDate: null
      };
      this.showOfferSidebar = true;
      offer.rentObject = this.searchResults.find(s => s.id === offer.rentObjectId);
      offer.nr = this.selectedOffers.length + 1;
      if (!offer.rentObject) return;
      this.$store.commit("offers/addSelectedOffer", {...offer, startDate: offer.startDate, endDate: offer.endDate});
      this.drawOffers();
    },
    reloadPage() {
      const newurl = window.location.protocol + "//" + window.location.host + window.location.pathname;
      window.history.pushState({path:newurl},'',newurl);
      window.location.reload();
    },
    jumpToBooking(r) {
      if (!r) return this.detectQueryParameters();
      if (r.startDate instanceof Date === false) {
        r.startDate = DateTime.fromISO(r.startDate).toJSDate();
        r.endDate = DateTime.fromISO(r.endDate).toJSDate();
      }
      this.currentDate = DateTime.fromJSDate(r.startDate).minus({days: xStepSizeWidthCount}).set({hour: 18}).toJSDate();
      // this.highlightRange = r;

      // We not only jump to the date but also to the rentObject
      this.yOffsetScroll = this.searchResults.findIndex(s => s.id === r.rentObjectId);
      this.resizeEvent();
    }
  }
};
</script>

<style lang="scss" scoped>
#canvas-wrapper {
  position: absolute;
  width: 100%;
  height: calc(100vh - 260px);
  overflow: hidden;
}

.rent-object-cover {
  position: absolute;
  left: 0;
  top: 0;
  border: solid 1px rgba(#64748b, 0.56);
  background-color: white;
  z-index: 1;
  .top {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .bottom {
    font-weight: 500;
    border-top: solid 1px rgba(#64748b, 0.56);
    padding: 0 $sm-space;
    margin-top: -1px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
